import { gql } from '@apollo/client';

export const REFINE_BIO = gql`
  mutation RefineBio($originalText: String!) {
    refineBio(originalText: $originalText) {
      refinedText
    }
  }
`;